import { ElectricalAspectSearchComponentBase } from './electrical-aspect-search.component.base';
import { ChangeDetectorRef, Component, Injector, Input, Optional, QueryList, ViewChildren } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatColumnDef, MatTable } from '@angular/material/table';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Columns, CrudRevisionEntity, FormStorage, UserStorage } from '@scisys-uim/uim-common';
import { ElectricalAspect, Asset } from 'assets-model';
import { ElectricalAspectService, RefCodeStorage } from 'assets-service';


// @Component({
//   selector: 'app-electrical-aspect-search',
//   templateUrl: './electrical-aspect-search.component.html',
//   styleUrls: ['./electrical-aspect-search.component.scss']
// })
export class ElectricalAspectSearchComponent extends ElectricalAspectSearchComponentBase {

  constructor(protected route: ActivatedRoute,
    protected router: Router,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected electricalAspectService: ElectricalAspectService,
    protected refCodeStorage: RefCodeStorage,
    protected fb: FormBuilder,
    protected formStorage: FormStorage,
    protected injector: Injector) {
    super(route, router, userStorage, dialog, electricalAspectService, refCodeStorage, fb, formStorage, injector);
  }

  protected onInitAsyncComplete() {
    super.onInitAsyncComplete();

    if (!this.restoreFormFromParams(this.searchForm)) {
      this.resetSearchForm();
      this.restoreFormChanges();
    }
  }

  resetSearchForm() {
    // placeholder
  }

  protected transformParamsToModelSetters(params: Params): {
    [key: string]: (value: any, formControl: FormControl, formControlName: string) => void
  } {
    return this.transformAllPropertiesToModelSetters();
  }

}
@Component({
  selector: 'app-electrical-aspect-search-result-columns',
  templateUrl: './electrical-aspect-search-result-columns.component.html',
  styleUrls: ['./electrical-aspect-search.component.scss']
})
export class ElectricalAspectSearchResultColumnsComponent {
  @ViewChildren(MatColumnDef) columnDefs: QueryList<MatColumnDef>;

  constructor(@Optional() public table: MatTable<any>, private cdRef: ChangeDetectorRef) { }

  @Input()
  columns: Columns;

  @Input()
  cellClassFn = (element: ElectricalAspect, fieldName: any, relationshipGetter?: (element: Asset) => any, previousRevisionGetter?: (record: CrudRevisionEntity) => CrudRevisionEntity) => { };

  @Input()
  assetGetter: (record: any) => Asset;

  @Input()
  electricalAspectGetter: (record: any) => ElectricalAspect;

  @Input()
  previousRevisionGetter: (record: CrudRevisionEntity) => CrudRevisionEntity

  ngOnInit() {
    if (!this.assetGetter) {
      this.assetGetter = (record: any) => record;
    }
    if (!this.electricalAspectGetter) {
      this.electricalAspectGetter = (record: any) => record?.electricalAspect;
    }

    if (this.table) {
      this.cdRef.detectChanges();
      this.columnDefs.forEach(columnDef => {
        this.table.addColumnDef(columnDef);
      });
    }
  }

  cellClass(element: ElectricalAspect, fieldName: string, relationshipGetter?: (element: Asset) => any, previousRevisionGetter?: (record: CrudRevisionEntity) => CrudRevisionEntity) {
    return this.cellClassFn(element, fieldName, relationshipGetter, previousRevisionGetter);
  }
}

